import { Component, input, output, inject, ChangeDetectionStrategy } from '@angular/core';
import { IconComponent } from '@claas/claas-ui-components';
import { take } from 'rxjs';
import { UseHttpImageSourcePipe } from '@cde-fe-app/app/custom-pipes/pipe/authImage.pipe';
import { TimeDifferencePipe } from '@cde-fe-app/app/custom-pipes/pipe/time-difference.pipe';
import { INotification } from '@cde-fe-app/app/shared/models/notification.model';
import { NotificationsService } from '@cde-fe-app/app/shared/services/notifications.service';

@Component({
  selector: 'app-notification-tile',
  templateUrl: './notification-tile.component.html',
  styleUrls: ['./notification-tile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [UseHttpImageSourcePipe, TimeDifferencePipe, IconComponent],
})
export class NotificationTileComponent {
  readonly notificationsService = inject(NotificationsService);
  notification = input.required<INotification>();
  closeSidePanel = output();

  defaultImage = '/assets/icons/default-tractor-icon-small.svg';

  navigate() {
    this.notificationsService
      .updateLastVisitToNotification()
      .pipe(take(1))
      .subscribe(() => {
        /* empty */
      });

    window.open(this.notification().link.linkUri, this.notification().link.target);

    this.closeSidePanel.emit();
  }
}
